import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const NetworkConnectionModal = ({isOpen}) => {

    return (
        <div>
            <Modal isOpen={isOpen}>
                <ModalHeader>
                DISCONNECTION NOTIFICATION
                </ModalHeader>
                <ModalBody className=' font-weight-bold'>
                  <h6>Dear Candidate,</h6>
                  <p>Your computer has <span className='text-danger'>lost connection</span> to the exam server.</p>
                  <p>Kindly contact an administrator.</p>
                </ModalBody>
                <ModalFooter>
                {' '}
                {/* <Button color='success' onClick={toggle}>
                    Okay
                </Button> */}
                </ModalFooter>
            </Modal>
        </div>
    );
}

// const mapStateToProps = state => {
//   return { candidate: }
// }

export default NetworkConnectionModal;
